import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";
import { BASPATH } from "../../config/appConfig";

 
const AboutUsComponent = Loadable({
  loader: () => import("./components/about"),
  loading: Loading
});
 
export const routes = [
  {
    path: BASPATH + "about",
    exact: true,
    name: "about",
    element: AboutUsComponent
  },
];

export * from "../auth/components";
